import { Switch } from "@/components/ui/switch";
import { DAYS } from "@/lib/format";

export const DEFAULT_HOURS = Object.fromEntries(
  DAYS.map(([k], i) => [k, { enabled: i < 5, start: "09:00", end: "17:00" }])
);

export default function HoursEditor({ value, onChange }) {
  const update = (day, patch) => onChange({ ...value, [day]: { ...value[day], ...patch } });
  return (
    <div className="divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white" data-testid="hours-editor">
      {DAYS.map(([key, label]) => {
        const h = value[key] || { enabled: false, start: "09:00", end: "17:00" };
        return (
          <div key={key} className="flex flex-wrap items-center gap-3 px-4 py-3">
            <div className="flex w-36 items-center gap-3">
              <Switch data-testid={`hours-toggle-${key}`} checked={h.enabled} onCheckedChange={(v) => update(key, { enabled: v })} />
              <span className="text-sm font-medium text-slate-800">{label}</span>
            </div>
            {h.enabled ? (
              <div className="flex items-center gap-2">
                <input type="time" data-testid={`hours-start-${key}`} value={h.start} onChange={(e) => update(key, { start: e.target.value })} className="h-10 rounded-lg border border-slate-200 px-2 text-sm" />
                <span className="text-slate-400">to</span>
                <input type="time" data-testid={`hours-end-${key}`} value={h.end} onChange={(e) => update(key, { end: e.target.value })} className="h-10 rounded-lg border border-slate-200 px-2 text-sm" />
              </div>
            ) : (
              <span className="text-sm text-slate-400">Closed</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
